var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, styled } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { BsChevronUp } from 'react-icons/bs';
export var InfoToggle = function (_a) {
    var title = _a.title, children = _a.children;
    var _b = useState(false), isExpanded = _b[0], setIsExpanded = _b[1];
    return (_jsxs("div", __assign({ className: "grid place-items-center" }, { children: [_jsxs(Link, __assign({ component: "button", "aria-expanded": isExpanded, "aria-controls": "info-content", type: "button", variant: "link", onClick: function () { return setIsExpanded(!isExpanded); }, className: "flex items-center gap-2 mb-2" }, { children: [title, isExpanded ? (_jsx(BsChevronUp, { size: "1rem", color: "black" })) : (_jsx(BsChevronUp, { size: "1rem", color: "black", className: "transform rotate-180" }))] })), _jsx(AnimatePresence, { children: isExpanded && (_jsx(MotionWrapper, __assign({ id: "info-content", initial: "collapsed", className: "max-w-sm", animate: "open", exit: "collapsed", variants: {
                        open: { opacity: 1, height: 'auto' },
                        collapsed: { opacity: 0, height: 0 },
                    } }, { children: children }), "content")) })] })));
};
var MotionWrapper = motion(styled('div')({
    overflow: 'hidden',
    textAlign: 'center',
    fontFamily: 'Quasimoda',
}));
